// A page a visitor opened before signing in (an invite or a cohort), so sign-up and onboarding
// can bring them back to it instead of the dashboard. Only these public paths are honoured.
const KEY = "hm_return_to";
const ALLOWED = /^\/(invite\/[A-Za-z0-9-]+|cohorts(\/[a-z0-9-]+)?)$/;

export function rememberReturn(path) {
  if (!ALLOWED.test(path)) return;
  try { localStorage.setItem(KEY, path); } catch { /* storage unavailable: the visitor lands on the dashboard */ }
}

// A visitor who pressed "Join" on a cohort before having an account. Once they are signed in with a
// finished profile, the cohort page completes that join for them. Expires so a stale click can't fire weeks later.
const JOIN_KEY = "hm_pending_cohort_join";
const JOIN_TTL_MS = 3 * 24 * 60 * 60 * 1000;

export function rememberCohortJoin(slug) {
  try { localStorage.setItem(JOIN_KEY, JSON.stringify({ slug, at: Date.now() })); } catch { /* storage unavailable */ }
}

export function pendingCohortJoin() {
  try {
    const saved = JSON.parse(localStorage.getItem(JOIN_KEY) || "null");
    if (saved?.slug && Date.now() - saved.at < JOIN_TTL_MS) return saved.slug;
    localStorage.removeItem(JOIN_KEY);
  } catch { /* unreadable: nothing pending */ }
  return null;
}

export function clearCohortJoin() {
  try { localStorage.removeItem(JOIN_KEY); } catch { /* nothing to clear */ }
}

export function takeReturn(fallback = "/dashboard") {
  try {
    const path = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    return path && ALLOWED.test(path) ? path : fallback;
  } catch {
    return fallback;
  }
}
